// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"b4ab7b22","555":"5e500ced","571":"93457d22","584":"84c97e34","801":"1e47720b","839":"377f8cb4","845":"99cab66c","925":"e31b2a08"}[chunkId] + ".chunk.js";
};